import {
  hoverFunc,
  telLinkFunc,
  animeLinkFunc
} from "../common/_hoverFunc";

import Swiper from 'swiper';

const campaignPage = $('#campaign').length;
const campaignSlide = $('#nowonSlider');
const campaignSlideStatus = campaignSlide.parent();
const slideItem = $('.campaignOtherSlideItem');

export function campaignFunc() {
  if (campaignPage) {
    if (campaignSlide.length) {
      const slideItemCount = slideItem.length;
      const breakPoint = 750;
      let mySwiper;
      let mySwiperBool;

      const createSwiper = () => {
        mySwiper = new Swiper('#nowonSlider', {
          speed: 1000,
          slideToClickedSlide: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            751: {
              slidesPerView: 3,
              spaceBetween: 8,
              centeredSlides: false
            },
            320: {
              slidesPerView: 1.28,
              spaceBetween: 22.5,
              centeredSlides: true
            }
          },
          preloadImages: false,
          lazy: {
            elementClass: 'lazyload',
            loadPrevNextAmount: 2,
            loadPrevNext: true
          }
        });
      }

      if (slideItemCount >= 4) {
        createSwiper();
      } else {
        if (breakPoint < window.innerWidth) {
          mySwiperBool = false;
          campaignSlideStatus.addClass('notSlide');
        } else {
          createSwiper();
          mySwiperBool = true;
        }
        window.addEventListener('resize', () => {
          if (breakPoint < window.innerWidth && mySwiperBool) {
            mySwiper.destroy(false, true);
            mySwiperBool = false;
            campaignSlideStatus.addClass('notSlide');
          } else if (breakPoint >= window.innerWidth && !(mySwiperBool)) {
            createSwiper();
            mySwiperBool = true;
            campaignSlideStatus.removeClass('notSlide');
          }
        }, false);
      }
    }
  }
}


export function ajaxFunc() {
  
  /* --------------------------------------------------------------------
    You Tube処理
    -------------------------------------------------------------------- */
    var youtubeFunc = function () {
        $('p').find('iframe').wrap('<div class="youtube2"></div>');
    }
    youtubeFunc();
    
  
  let jsAjax = $('#jsAjax');
  let totalPostRes = $('.postCount').text();

  if (totalPostRes <= 6) {
    jsAjax.css('display', 'none');
  }

  jsAjax.on('click', function () {
    let displayInPostLength = $('.campaignFinList li').length;
    var post = displayInPostLength;
    var postData = {
      'action': 'ajax_test',
      'post': post,
    };
    // Ajaxで送信
    $.ajax({
      url: ajaxurl,
      method: 'post',
      dataType: 'text',
      data: postData,
    }).done(function (res) {

      $('.campaignFinList').append(res);
      jsAjax.css('display', 'none');
      hoverFunc();

    }).fail(function (xhr, textStatus, errorThrown) {
      console.log("NG:" + xhr.status);
    });
  });
}
